const initState = '';
const funcToExport = (state = initState, action) => {
  switch (action.type) {
    case 'MTI_TYPES_IMAGE_VIEWED_OBJ':
      return action.payload;
    default:
      return state;
  }
};
export default funcToExport;
